import styled from 'styled-components';

// Sized to match the chat-bubble icon (16px); shared shape with ExamplesIcon.
const SidebarNavIconSvg = styled.svg`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: var(--text-secondary);
`;

export default function TasksIcon() {
  // Checkbox with a checkmark — represents scheduled tasks (cron).
  return (
    <SidebarNavIconSvg viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <rect
        x="3"
        y="3"
        width="14"
        height="14"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M6.5 10L9 12.5L13.5 7.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SidebarNavIconSvg>
  );
}
